/* PW v91: product page "Pairs well with" and quick add.
   Order: Shopify complementary recommendations, then the hand-picked custom.pairs_with cards
   already in the page, then Shopify related recommendations. Up to 4, never the product on
   screen and never one already shown in "Collect the series". Quick add posts to /cart/add.js
   and hands the result to the cart drawer, which opens with Cash's reaction.
   v96.1: digital (non-shipping) recommendations arrive inside <template data-pw-digital> and are
   only used when the product on screen is itself digital (data-ship="0"). */
(function () {
  'use strict';
  var MAX = 4;

  function recs(base, pid, intent, withDigital) {
    var url = base + '?section_id=pw-recs&limit=8&intent=' + intent + '&product_id=' + encodeURIComponent(pid);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var d = document.createElement('div');
        d.innerHTML = html;
        var cards = Array.prototype.slice.call(d.querySelectorAll('li.pw-mc[data-pid]'));
        if (withDigital) {
          d.querySelectorAll('template[data-pw-digital]').forEach(function (t) {
            cards = cards.concat(Array.prototype.slice.call(t.content.querySelectorAll('li.pw-mc[data-pid]')));
          });
        }
        return cards;
      })
      .catch(function () { return []; });
  }

  function fillPairs() {
    var box = document.querySelector('[data-pw-pdp-pairs]');
    if (!box) return;
    var row = box.querySelector('[data-pw-pairs-row]');
    var pid = box.getAttribute('data-product-id');
    var base = box.getAttribute('data-recs-url') || '/recommendations/products';
    var digitalPage = box.getAttribute('data-ship') === '0';
    var skip = {};
    skip[pid] = 1;
    document.querySelectorAll('[data-pw-series] [data-pid]').forEach(function (li) { skip[li.getAttribute('data-pid')] = 1; });
    var curated = Array.prototype.slice.call(row.querySelectorAll('li.pw-mc[data-pid]'));

    Promise.all([recs(base, pid, 'complementary', digitalPage), recs(base, pid, 'related', digitalPage)]).then(function (res) {
      var out = [], seen = {};
      [res[0], curated, res[1]].forEach(function (list) {
        list.forEach(function (li) {
          var id = li.getAttribute('data-pid');
          if (out.length >= MAX || skip[id] || seen[id]) return;
          seen[id] = 1;
          out.push(li);
        });
      });
      if (!out.length) { box.hidden = true; return; }
      row.innerHTML = '';
      out.forEach(function (li) { row.appendChild(li); });
      box.hidden = false;
    });
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  function quickAdd(form) {
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
    var body = new FormData(form);
    var el = drawer();
    var sections = [];
    try { sections = el.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }
    var done = function (msg) {
      if (!btn) return;
      btn.textContent = msg || 'Added';
      setTimeout(function () { btn.disabled = false; btn.innerHTML = label; }, 1600);
    };
    fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { done(/sold out|stock|inventory/i.test(data.description || '') ? 'Sold out' : 'Try again'); return; }
        if (el && el.renderContents && data.sections) {
          el.renderContents(data);
          done('Added');
        } else {
          window.location.href = (window.routes && routes.cart_url) || '/cart';
        }
      })
      .catch(function () { done('Try again'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-pw-qa]');
    if (!form) return;
    e.preventDefault();
    quickAdd(form);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillPairs);
  else fillPairs();
})();
